/**
 * 预设案例数据模块
 * 数据存储在 presets.json，此文件提供类型定义和导出
 */

// 编程概念类型
export interface BlockConcept {
  name: string;        // 概念名称
  description: string; // 详细解释
}

// 预设案例类型定义
export interface BlocksPreset {
  id: string;
  name: string;
  description: string;
  detail: string; // 详细介绍
  concepts: BlockConcept[]; // 涉及的编程概念
  tips: string; // 学习提示
  expectedOutput: string; // 预期输出/运行结果
  timeEstimate: string; // 预计学习时间
  prerequisites: string[]; // 前置知识要求
  icon: string; // SVG 图标
  gradient: string; // 渐变背景
  difficulty: 'easy' | 'medium' | 'hard';
  tags: string[];
  blocks: string; // Blockly XML 格式
}

// 导入 JSON 数据
import presetsData from './presets.json';

// 导出预设案例数据
export const BLOCK_PRESETS: BlocksPreset[] = presetsData as BlocksPreset[];
